(function () {
  'use strict';

  var root = document.documentElement;

  var mobileMenu = document.getElementById('mobile-menu');
  var scrim = document.getElementById('scrim');

  if (!mobileMenu) return;

  var closeBtn = mobileMenu.querySelector('[data-close]');
  var openBtn = document.querySelector('[data-open="mobile-menu"]');

  function openMenu() {
    mobileMenu.classList.add('is-open');
    if (scrim) scrim.classList.add('is-on');
    root.classList.add('is-locked');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    var focusables = mobileMenu.querySelectorAll('a[href], button:not([disabled]), input, textarea, select, summary, [tabindex]:not([tabindex="-1"])');
    if (focusables.length) focusables[0].focus({ preventScroll: true });
  }

  function closeMenu() {
    mobileMenu.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-on');
    root.classList.remove('is-locked');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    if (openBtn) openBtn.focus({ preventScroll: true });
  }

  if (openBtn) {
    openBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openMenu();
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeMenu);
  }

  if (scrim) {
    scrim.addEventListener('click', closeMenu);
  }

  mobileMenu.querySelectorAll('[data-close]').forEach(function (el) {
    el.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
      closeMenu();
    }
  });

  mobileMenu.querySelectorAll('details summary').forEach(function (summary) {
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      var details = summary.parentElement;
      var isOpen = details.open;
      mobileMenu.querySelectorAll('details').forEach(function (d) {
        if (d !== details) d.open = false;
      });
      details.open = !isOpen;
    });
  });

  window.TDCMobileMenu = {
    open: openMenu,
    close: closeMenu
  };
})();